import { render, staticRenderFns } from "./Lodgingshiverr.vue?vue&type=template&id=1432bd52&scoped=true&"
import script from "./Lodgingshiverr.vue?vue&type=script&lang=js&"
export * from "./Lodgingshiverr.vue?vue&type=script&lang=js&"
import style0 from "./Lodgingshiverr.vue?vue&type=style&index=0&id=1432bd52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1432bd52",
  null
  
)

export default component.exports